export const disabledProps = {
  opacity: 1,
  borderColor: "gray.100",
  color: "gray.400",
  bg: "gray.100",
  cursor: "default",
};
